
import Page from 'Scripts/classes/Page'

export default class extends Page {
  constructor() {
    super(
      'editorial',
      {
      container: '.editorial',
      elements: {

      }
    })


  }

  /**
  * Animations.
  */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {    
    return super.onResize()
  }

}

